import React from 'react'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {ContentNotes} from '../../Molecules/BaseContentBlocks/ContentNotes'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {Spacer} from '../../../../Common/Components/Spacer'

type SendConfirmMailContentProps = {
  title: string
  topMessage: string
  note: string[]
  logoImgUrl?: string
  dataTestId?: string
}
export const SendConfirmMailContent: React.VFC<SendConfirmMailContentProps> = (props) => {
  return (
    <ContentBlock data-testid={props.dataTestId ?? 'block-send-confirm-mail'}>
      <ContentTitle logoUrl={props.logoImgUrl}>{props.title}</ContentTitle>
      <ContentTopMessage>{props.topMessage}</ContentTopMessage>
      <Spacer mt={'18px'}>
        <ContentNotes notes={props.note}/>
      </Spacer>
    </ContentBlock>
  )
}
